import { shape, array, arrayOf, string, number } from 'prop-types';

const CategoryProp = {
  id: number.isRequired,
  name: string.isRequired,
  children: array
};

CategoryProp.children = arrayOf(shape(CategoryProp));

export const CategoryPropType = shape(CategoryProp);

const CategoriesPropType = arrayOf(CategoryPropType);

export default CategoriesPropType;
